export const PLATFORM_NAME = 'Turbine Workforce';
export const TINYMCE_KEY = process.env.REACT_APP_TINYMCE;
export const TURBINE_ADMIN_EMAIL = 'hello@turbineworkforce.com';
export const TURBINE_ADMIN_BCC_EMAILS = 'alan@turbineworkforce.com,josh@turbineworkforce.com';
export const UPSTREAM_CODING = '7bc6APXSkbx7hNHrVHljjm';
export const CLASS_COLOR_DEFAULT = '#b3bac5';
// CCAC
export const TRUST_COURSE_ID = '58Bbxo6dMq9wAExp3TT8IE';
export const PHOTONICS_COURSE_ID = '3X4Y7HfmUmWY3SITrkAODC';
